module.exports = __webpack_public_path__ + "img/Flag_of_Gabon.4544cd0b.svg";